var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuilding2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M570.7,1067.28,1067.28,570.7a43.41,43.41,0,0,0,0-61.4L570.7,12.72a43.41,43.41,0,0,0-61.4,0L12.72,509.3a43.41,43.41,0,0,0,0,61.4l84.13,84.13a16.17,16.17,0,0,0,1.23,1.86L301.23,859.84a18,18,0,0,0,25.4-25.39L123.48,631.3c-.07-.06-.15-.08-.22-.14L60.05,567.94a39.51,39.51,0,0,1,0-55.88l452-452a39.53,39.53,0,0,1,55.89,0l452,452a39.51,39.51,0,0,1,0,55.88l-452,452a39.51,39.51,0,0,1-55.89,0l-65.36-64.88L421.82,979.8l87.48,87.48A43.41,43.41,0,0,0,570.7,1067.28Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M782.57,667H733.65V606.33a7.43,7.43,0,0,0-14.86,0v168H591.35V553.79H718.79v17.9a7.43,7.43,0,0,0,14.86,0V546.35a7.43,7.43,0,0,0-7.43-7.43H624.76V298.22a7.43,7.43,0,0,0-7.42-7.43H462.89a7.43,7.43,0,0,0-7.43,7.43V409.3h-96a7.42,7.42,0,0,0-7.41,7.43V599.3H297.43a7.43,7.43,0,0,0-7.43,7.43V781.79a7.43,7.43,0,0,0,7.43,7.43H782.57a7.43,7.43,0,0,0,7.43-7.43V674.44A7.43,7.43,0,0,0,782.57,667ZM352,774.38H304.85V614.14H352Zm154.45,0H366.83V733.32h139.6Zm0-105.91H439.51a7.43,7.43,0,1,0-.54,14.85h67.46v35.15H366.83V683.32h38a7.43,7.43,0,1,0,.54-14.85H366.83V633.33h139.6Zm0-50H366.83V583.33h139.6Zm0-50H366.83V533.33h139.6Zm0-50H366.83V483.33h139.6Zm0-50H366.83V424.15h139.6Zm70.07,77.87v228H521.28V416.73a7.43,7.43,0,0,0-7.42-7.43H503.73V394.45a7.43,7.43,0,1,0-14.85-.55,5,5,0,0,0,0,.55V409.3H470.32V305.64H609.91V538.93h-26a7.43,7.43,0,0,0-7.41,7.42Zm198.65,228h-41.5V681.86h41.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M583.93,451.68a7.43,7.43,0,0,0-7.43,7.42v22.28a7.43,7.43,0,0,0,14.85,0V459.1a7.42,7.42,0,0,0-7.42-7.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M540.12,451.68a7.43,7.43,0,0,0-7.43,7.42v22.28a7.43,7.43,0,0,0,14.85,0V459.1a7.42,7.42,0,0,0-7.42-7.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M583.93,387a7.43,7.43,0,0,0-7.43,7.43v22.28a7.43,7.43,0,0,0,14.85,0V394.45A7.43,7.43,0,0,0,583.93,387Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M540.12,387a7.43,7.43,0,0,0-7.43,7.43v22.28a7.43,7.43,0,0,0,14.85,0V394.45A7.43,7.43,0,0,0,540.12,387Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M496.31,322.37a7.43,7.43,0,0,0-7.43,7.42v22.29a7.43,7.43,0,0,0,14.85,0V329.79A7.42,7.42,0,0,0,496.31,322.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M583.93,322.37a7.43,7.43,0,0,0-7.43,7.42v22.29a7.43,7.43,0,0,0,14.85,0V329.79A7.42,7.42,0,0,0,583.93,322.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M540.12,322.37a7.43,7.43,0,0,0-7.43,7.42v22.29a7.43,7.43,0,0,0,14.85,0V329.79A7.42,7.42,0,0,0,540.12,322.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M580,517.79a7.42,7.42,0,1,0,11,8.59C593.14,519.91,585.71,514.19,580,517.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M540.12,516.65a7.43,7.43,0,0,0-7.43,7.42v22.28a7.43,7.43,0,0,0,14.85.54,4.86,4.86,0,0,0,0-.54V524.07a7.42,7.42,0,0,0-7.42-7.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M540.12,711.57a7.43,7.43,0,0,0-7.43,7.42v22.28a7.43,7.43,0,0,0,14.85,0V719a7.42,7.42,0,0,0-7.42-7.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M540.12,646.59a7.43,7.43,0,0,0-7.43,7.42v22.28a7.43,7.43,0,0,0,14.85,0V654A7.43,7.43,0,0,0,540.12,646.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M540.12,581.62a7.43,7.43,0,0,0-7.43,7.42v22.27a7.43,7.43,0,1,0,14.85.55,5,5,0,0,0,0-.55V589.05A7.43,7.43,0,0,0,540.12,581.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M696.15,709.3H614a7.43,7.43,0,1,0,0,14.86h82.17a7.43,7.43,0,1,0,0-14.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M696.15,744.41H614a7.43,7.43,0,1,0-.54,14.85h82.69a7.43,7.43,0,1,0,.54-14.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M696.15,674.21H614a7.43,7.43,0,1,0-.54,14.85h82.69a7.43,7.43,0,1,0,.54-14.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M696.15,568.89H614a7.45,7.45,0,0,0,0,14.9h82.15a7.43,7.43,0,1,0,.54-14.85,4.86,4.86,0,0,0-.54,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M696.15,639.1H614A7.43,7.43,0,0,0,614,654h82.15a7.43,7.43,0,0,0,0-14.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M696.15,604H614a7.43,7.43,0,0,0,0,14.85h82.15a7.43,7.43,0,0,0,0-14.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M328.42,626a7.43,7.43,0,0,0-7.42,7.43v19.31a7.43,7.43,0,0,0,14.85,0V633.38A7.43,7.43,0,0,0,328.42,626Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M328.42,677.19a7.43,7.43,0,0,0-7.42,7.43v19.29a7.43,7.43,0,0,0,14.85.55,5,5,0,0,0,0-.55V684.62a7.41,7.41,0,0,0-7.41-7.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M328.42,728.42a7.43,7.43,0,0,0-7.42,7.43v19.31a7.43,7.43,0,0,0,14.85,0V735.85A7.43,7.43,0,0,0,328.42,728.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M754.4,699.68a7.43,7.43,0,0,0-7.43,7.43v21a7.43,7.43,0,0,0,14.85.54,4.86,4.86,0,0,0,0-.54v-21A7.43,7.43,0,0,0,754.4,699.68Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding2);
export default __webpack_public_path__ + "static/media/building2.9cd64170b30e61dfbb46b196d79dd5c8.svg";
export { ForwardRef as ReactComponent };